/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Api } from '../../api';
import axios from 'axios';
import {
  errorToast,
  informativeToast,
  useOutsideClick,
  successToast,
  getJWTToken
} from '../../utils/helper';
import SearchInput from '../../component/common/Input/SearchInput';
import Table from '../../component/common/Table';
import React, { Fragment } from 'react';
import { useRef, useState, useEffect } from 'react';
import { Calendar } from 'react-date-range';
import { Helmet } from 'react-helmet';
import { PER_PAGE } from '../../utils/constants';
import { Transition, Dialog } from '@headlessui/react';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import Loader from '../../component/common/Loader';
import Topbar2 from './Topbar';
import Pagination from '../../component/common/Pagination/Pagination';
import DashboardInfoCard from '../../component/common/DashboardInfoCard';
import { ShoorahTestB2CUsersPageData as pageData } from '../../utils/pageContent';

function TestFeature({topbarShow = true}) {
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  const [startDate, setStartDate] = useState();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState(-1);
  const [sortBy, setSortBy] = useState('');
  const [filterQuery, setFilterQuery] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showCompanyInfo, setShowCompanyInfo] = useState(false);
  const [companyInfoObject, setCompanyInfoObject] = useState({});
  const [totalTestsInsights, settotalTestsInsights] = useState(0);
  const [completedTestsInsights, setcompletedTestsInsights] = useState(0);
  const [topTestTitleInsights, settopTestTitleInsights] = useState('');
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const [filterCriteria, setFilterCriteria] = useState({
    companySubscription: ''
  });

  const columns = [
    {
      title: pageData.tableHeaderText.name,
      key: 'name',
      sortable: false,
      type: 'text',
      align: 'left',
      rowClassName: '!text-base font-medium'
    },
    {
      title: pageData.tableHeaderText.selfTakenTest,
      key: 'self_tests',
      sortable: false,
      type: 'text',
      align: 'center'
    },
    {
      title: pageData.tableHeaderText.otherUsersTest, // Fixed title to match data
      key: 'other_tests', // Fixed key to match data structure
      sortable: false,
      type: 'text',
      align: 'center'
    },
    {
      title: pageData.tableHeaderText.reTakenTest,
      key: 'repeated_tests',
      sortable: false,
      type: 'text',
      align: 'left'
    }
  ];

  const handlePagination = (
    pageNumber,
    pageSize,
    searchKey = '',
    sortByKey = '',
    orderByKey = '',
    startDate = '',
    endDate = ''
  ) => {
    setLoader(true);

    if (sortByKey === '') sortByKey = 'name';
    if (orderByKey === -1) orderByKey = 'desc';

    Api.getAllUsersShoorahTestResults(pageNumber, pageSize, sortByKey, orderByKey, searchKey)
      .then((response) => {
        setLoader(false);

        if (response?.data) {
          if (response?.data?.data && Array.isArray(response.data.data)) {
            setUsersList(
              response.data.data.map((item) => ({
                ...item,
                other_tests: item.other_tests || 0
              }))
            );

            setCurrentPage(pageNumber);
            setTotalCount(response?.data?.meta?.totalRecords || response.data.data.length);
            setLoader(false);
          } else {
            setLoader(false);
            setUsersList([]);
            setTotalCount(0);
          }
        } else if (response?.code === 401) {
          errorToast(response?.message || pageData.unAuthorizedErrorMessage);
          setLoader(false);
        } else if (response?.data?.meta?.code === 0) {
          setLoader(false);
          setCurrentPage(1);
          setUsersList([]);
          setTotalCount(0);
          errorToast(response?.data?.meta?.message || pageData.noDataFoundErrorMessage);
        } else {
          setLoader(false);
          setUsersList([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        setLoader(false);
        setUsersList([]);
        setTotalCount(0);
        errorToast(pageData.failedToFetchDataErrorMessage);
      });
  };

  const getB2CUserTestResultsOverview = () => {
    setLoader(true);
    Api.getTestResultsOverviews('b2c-users')
      .then((response) => {
        if (response?.data?.meta?.code === 1) {
          settotalTestsInsights(response?.data?.data?.summary?.total_tests || 0);
          setcompletedTestsInsights(response?.data?.data?.summary?.completed_tests || 0);
          settopTestTitleInsights(response?.data?.data?.top_tests?.[0]?.test_title || 'No data');
        }
      })
      .catch((error) => {
        console.log('error we while making B2C Users Test Results OverView API call', error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    handlePagination(1, selectedPerPage?.value, searchTerm, sortBy, sortOrder);
    getB2CUserTestResultsOverview();
    return () => {
      if (debounceTimeout) clearTimeout(debounceTimeout);
    };
  }, []);

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, searchTerm, sortBy, sortOrder);
  };

  const refreshTable = () => handlePagination(1, selectedPerPage?.value, '', sortBy, sortOrder);

  const resetHandler = () => {
    setFilterCriteria({
      companySubscription: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, selectedPerPage.value, searchTerm, '', sortBy, sortOrder);
  };

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate);
    handlePagination(1, selectedPerPage.value, searchTerm, sortBy, sortOrder, formattedDate);
    setIsOpen2(false);
  };

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  const getIndividualTestResults = async (testID, testTitle) => {
    setLoader(true);

    try {
      console.log('Starting download for testID:', testID);

      const response = await Api.getUserTestReportBlob(testID);

      if (response?.data) {
        const contentType = response.headers['content-type'] || response.headers['Content-Type'];
        console.log('Content-Type:', contentType);

        const blob = new Blob([response.data], { type: 'application/pdf' });

        if (blob.size === 0) {
          errorToast(pageData.emptyReceivedFileErrorMessage);
          return;
        }

        const downloadUrl = URL.createObjectURL(blob);
        const timestamp = new Date().toISOString().slice(0, 10);
        const filename = `${testTitle.replace(/\s+/g, '_')}_Report_${timestamp}.pdf`;

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          URL.revokeObjectURL(downloadUrl);
        }, 1000);

        successToast(pageData.downloadReportSuccessMessage);
      } else {
        errorToast(pageData.noDataReceivedErrorMessage);
      }
    } catch (error) {
      console.error('Download error:', error);
      errorToast(pageData.failedToDownloadReportErrormessage);
    } finally {
      setLoader(false);
    }
  };

  const handleViewUserTests = (item) => {
    setShowCompanyInfo(true);
    setCompanyInfoObject(item);
  };

  // Fixed rowsData mapping
  const rowsData = usersList.map((item) => {
    return {
      ...item,
      name: (
        <div>
          {item.name
            ? item.name
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
            : pageData.nullText}
        </div>
      ),
      self_tests: <div>{item?.self_tests || 0}</div>,
      other_tests: <div>{item?.other_tests || 0}</div>, // Fixed to match data structure
      repeated_tests: (
        <div className="flex items-center justify-between">
          <div className="ml-[15%]">{item.repeated_tests || 0}</div>
          <button
            onClick={() => handleViewUserTests(item)}
            className="mr-[20%] hover:opacity-70 transition-opacity"
          >
            {selectedTheme ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_520_11514)">
                  <path
                    d="M4.8165 1.63306C7.67052 3.06006 9.24519 4.48707 10.6875 7.06105C11.014 7.64381 11.014 8.35603 10.6875 8.93878C9.24519 11.5127 7.67052 12.9397 4.8165 14.3668"
                    stroke="#F3F4F6"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_520_11514">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(16) rotate(90)"
                    />
                  </clipPath>
                </defs>
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_520_11514)">
                  <path
                    d="M4.8165 1.63306C7.67052 3.06006 9.24519 4.48707 10.6875 7.06105C11.014 7.64381 11.014 8.35603 10.6875 8.93878C9.24519 11.5127 7.67052 12.9397 4.8165 14.3668"
                    stroke="#313B6B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_520_11514">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(16) rotate(90)"
                    />
                  </clipPath>
                </defs>
              </svg>
            )}
          </button>
        </div>
      )
    };
  });

  const subAdminStatusCards = [
    <DashboardInfoCard
      key="total-tests"
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            d="M40.4226 37.6837C40.6263 34.5623 40.7337 31.3224 40.7337 27.9999C40.7337 27.0959 40.7259 26.1979 40.7102 25.3068C40.6809 23.6431 40.1469 22.0195 39.1276 20.7043C37.3769 18.4452 35.8183 16.8884 33.4058 15.0495C32.7328 14.5365 31.9114 14.2576 31.0654 14.2383C30.0969 14.2163 29.0847 14.2051 28 14.2051C24.7305 14.2051 22.1188 14.3069 19.3808 14.5004C17.336 14.6449 15.711 16.2706 15.5774 18.3162C15.3736 21.4377 15.2663 24.6775 15.2663 27.9999C15.2663 31.3224 15.3736 34.5623 15.5774 37.6837C15.711 39.7294 17.336 41.3548 19.3808 41.4994C22.1188 41.6929 24.7305 41.7948 28 41.7948C31.2695 41.7948 33.8812 41.6929 36.6193 41.4994C38.6641 41.3548 40.2891 39.7294 40.4226 37.6837Z"
            fill="#B6C0F3"
            stroke="#313B6B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.8549 25.489C22.8549 25.489 23.9829 21.9729 25.838 21.7471C27.9078 21.4951 27.565 25.6129 29.6463 25.489C31.8905 25.3553 32.8198 20.6859 32.8198 20.6859"
            stroke="#313B6B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.7274 30.5295H33.2726"
            stroke="#313B6B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.7274 35.4373H33.2726"
            stroke="#313B6B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      }
      title={pageData.totalNumberOfTestTitle}
      value={totalTestsInsights}
    />,
    <DashboardInfoCard
      key="completed-tests"
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            d="M14.7346 29.4039C14.0289 28.5829 14.0285 27.3712 14.7339 26.55C15.2389 25.9621 15.7447 25.3846 16.2527 24.8163C16.0991 24.0795 15.9516 23.3358 15.8097 22.5832C15.6091 21.5194 16.2145 20.4699 17.2361 20.1113C17.9673 19.8547 18.6941 19.6075 19.4182 19.3693C19.6535 18.6545 19.8977 17.9366 20.1511 17.2139C20.5093 16.1922 21.5584 15.5861 22.6223 15.7864C23.371 15.9273 24.1114 16.074 24.8452 16.2269C25.4042 15.7276 25.9721 15.2303 26.55 14.7339C27.3712 14.0285 28.5829 14.0289 29.4039 14.7346C29.9847 15.2338 30.5551 15.7334 31.1163 16.2348C31.8625 16.0791 32.6156 15.9297 33.3771 15.7864C34.4411 15.5861 35.4901 16.1922 35.8484 17.2139C36.1018 17.9366 36.3458 18.6545 36.5812 19.3693C37.3053 19.6075 38.0322 19.8547 38.7633 20.1113C39.785 20.4699 40.3905 21.5193 40.1897 22.5832C40.0454 23.3487 39.8953 24.1051 39.7389 24.8542C40.2491 25.4249 40.7574 26.005 41.2653 26.596C41.9709 27.417 41.9714 28.6286 41.2659 29.4499C40.7608 30.0378 40.2551 30.6154 39.747 31.1839C39.9004 31.9205 40.0481 32.6643 40.1899 33.4168C40.3905 34.4808 39.785 35.5302 38.7635 35.8887C38.0322 36.1455 37.3053 36.3927 36.581 36.6308C36.3456 37.3456 36.1015 38.0636 35.8481 38.7862C35.4899 39.8079 34.4409 40.414 33.377 40.2137C32.6284 40.0728 31.8881 39.9261 31.1544 39.7733C30.5954 40.2725 30.0277 40.7697 29.4499 41.2659C28.6286 41.9714 27.417 41.9709 26.596 41.2653C26.0152 40.7661 25.4449 40.2665 24.8837 39.7652C24.1373 39.921 23.3842 40.0702 22.6225 40.2137C21.5586 40.414 20.5094 39.8079 20.1512 38.7862C19.8979 38.0636 19.6537 37.3456 19.4184 36.6308C18.6942 36.3925 17.9673 36.1455 17.2359 35.8887C16.2144 35.5302 15.6089 34.4808 15.8095 33.4168C15.9539 32.6511 16.1041 31.8945 16.2606 31.1452C15.7505 30.5746 15.2423 29.9947 14.7346 29.4039Z"
            fill="#B6C0F3"
            stroke="#313B6B"
            strokeWidth="2.288"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.3516 29.1621L26.7321 32.6482C28.3228 28.0787 29.6476 26.0736 32.648 23.3518"
            stroke="#313B6B"
            strokeWidth="2.288"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      }
      title={pageData.completedTestTitle}
      value={completedTestsInsights}
    />,
    <DashboardInfoCard
      key="top-test"
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <g transform="translate(12,12)">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.7482 20.6858C23.8244 19.1614 23.8639 17.5961 23.8639 16.0002C23.8639 15.3303 23.8569 14.6659 23.8433 14.0076C23.8259 13.1802 23.56 12.3747 23.0623 11.7135C22.0014 10.3037 21.0866 9.33578 19.7338 8.25604C19.069 7.72539 18.2402 7.44637 17.3897 7.43258C16.9455 7.42538 16.4846 7.42175 16.0003 7.42175C14.5218 7.42175 13.2612 7.45569 12.0283 7.52112C9.98126 7.62974 8.35438 9.26712 8.25228 11.3145C8.17626 12.8389 8.13672 14.4042 8.13672 16.0002C8.13672 17.5961 8.17626 19.1614 8.25228 20.6858C8.35438 22.7332 9.98126 24.3707 12.0283 24.4792C13.2612 24.5448 14.5218 24.5787 16.0003 24.5787C17.4787 24.5787 18.7393 24.5448 19.9723 24.4792C22.0193 24.3707 23.6461 22.7332 23.7482 20.6858Z"
                fill="#B6C0F3"
              />
              <path
                d="M12.701 12.8534H15.3406"
                stroke="#313B6B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.701 17.1182H19.2999"
                stroke="#313B6B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22.5789 2.7356C23.4276 2.82708 24.2682 2.92544 25.1002 3.02188C27.1365 3.25789 28.7607 4.88106 28.9892 6.91822L28.9958 6.97813C29.0867 7.78676 29.1783 8.60363 29.2634 9.42805M22.5789 29.2642C23.4276 29.1727 24.2682 29.0742 25.1002 28.9779C27.1365 28.7419 28.7607 27.1187 28.9892 25.0816L28.9958 25.0215C29.0867 24.2129 29.1783 23.396 29.2634 22.5718M9.42028 2.7356C8.57156 2.82708 7.73081 2.92544 6.89881 3.02188C4.8625 3.25789 3.23844 4.88106 3.00989 6.91822L3.00317 6.97813C2.91244 7.78676 2.82078 8.60363 2.73572 9.42805M9.42028 29.2642C8.57156 29.1727 7.73081 29.0742 6.89881 28.9779C4.8625 28.7419 3.23844 27.1187 3.00989 25.0816L3.00317 25.0215C2.91244 24.2129 2.82078 23.396 2.73572 22.5718"
                stroke="#313B6B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </g>
        </svg>
      }
      title={pageData.topPerformingTestTitle}
      value={topTestTitleInsights}
    />
  ];

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{pageData.metaTitle}</title>
        </Helmet>
        {loader ? <Loader /> : null}
        {topbarShow === true &&
        <Topbar2 title={pageData.pageTitle} infoBtn={false} />}
      </div>

      <div className="relative lg:pl-5 lg:mb-[45px]">
        {/* Search options, Date filter & Add Company are here */}
        <div className="sm:flex flex-col md:flex-row mt-5 justify-between items-center gap-3">
          {/* SearchBar */}
          <div className="flex items-center justify-center w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                // Debouncing search input
                if (debounceTimeout) clearTimeout(debounceTimeout);
                const timeout = setTimeout(() => {
                  handlePagination(1, selectedPerPage?.value, e.target.value, sortBy, sortOrder);
                }, 500);
                setDebounceTimeout(timeout);
              }}
              placeholder={pageData.searchPlaceholder}
              className="w-full sm:w-auto px-3 py-2"
            />
          </div>

          {/* Date calendar */}
          <div className="flex flex-col sm:flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
            <div
              ref={ref2}
              className="relative inline-block text-left w-full md:w-auto mb-2 md:mb-0"
            >
              <button
                type="button"
                onClick={() => setIsOpen2(!isOpen2)}
                className="flex justify-between items-center w-full md:w-auto px-5 py-2 text-xs md:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                <span>
                  {startDate
                    ? `${new Date(startDate).toLocaleDateString()}`
                    : pageData.dateCreatedBtnText}
                </span>
                {selectedTheme ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                      stroke="#F3F4F6"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                      stroke="#0B1D2E"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </button>
              {isOpen2 && (
                <div
                  className="absolute sm:-top-2 top-0 md:-left-96 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                  ref={calendarRef}
                >
                  <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                    <Calendar
                      className={'calendar text-sm sm:text-lg'}
                      onChange={handleChangeC}
                      nextLabel={
                        <button className="custom-next-button flex justify-center items-center">
                          <ChevronRightIcon className="w-8 h-8" />
                        </button>
                      }
                      maxDate={new Date()}
                      prevLabel={
                        <button className="custom-prev-button flex justify-center items-center">
                          <ChevronLeftIcon className="w-8 h-8" />
                        </button>
                      }
                      date={startDate ? new Date(startDate) : new Date()}
                      navigationLabel={({ date }) => (
                        <button
                          style={{ cursor: 'default', pointerEvents: 'none' }}
                          className="text-base"
                        >
                          {date.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long'
                          })}
                        </button>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Insights for the test Dashboard */}
        <div className="grid md:grid-cols-3 grid-cols-1 h-auto gap-4 mt-5">
          {subAdminStatusCards.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))}
        </div>

        <div className="mt-1.5 flex flex-col md:flex-row">
          <div className="mt-4 w-full md:w-[66.2%]">
            <Table
              columns={columns}
              data={rowsData}
              name={'company_table'}
              bottomBorder={totalCount > selectedPerPage?.value}
              refreshTable={refreshTable}
              loader={loader}
            />
          </div>

          {/* RIGHT PANEL */}
          <div className="mt-4 md:ml-[16px] w-full md:w-[32.4%]">
            <div className="w-full bg-white text-shoorah-lightBlack dark:bg-shoorah-darkBgTabColor border border-[#e7e8ea] dark:border-gray-600 rounded-2xl overflow-hidden">
              {/* INFO TOP BAR */}
              <div className="px-4 h-[60px] sm:px-6 py-3 sm:py-4 text-shoorah-gray3 bg-[#f8f8fa] dark:bg-shoorah-darkBgTabColor border-b border-[#e7e8ea] dark:border-gray-700 flex flex-row justify-between items-start sm:items-center gap-2 sm:gap-3">
                <span>{pageData.testInfoLabel}</span>
                {showCompanyInfo && (
                  <button
                    onClick={() => {
                      setShowCompanyInfo(false);
                      setCompanyInfoObject({});
                    }}
                    className="text-red-500 hover:text-red-700 text-sm"
                  >
                    ✕
                  </button>
                )}
              </div>

              <div className="space-y-0 divide-y pb-4 divide-gray-200 dark:divide-gray-700 grid">
                {/* MAIN CONTENT */}
                <div className={`min-h-[400px] transition-all duration-300`}>
                  {!showCompanyInfo ? (
                    <div className="flex items-center justify-center h-full p-8">
                      <div className="text-center">
                        <svg
                          className="mx-auto h-12 w-12 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                          {pageData.testInfoDescription}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="p-2">
                      {/* Check if tests_taken exists and has content */}
                      {!companyInfoObject?.tests_taken ||
                      companyInfoObject.tests_taken.length === 0 ? (
                        <div className="flex items-center justify-center h-32">
                          <div className="text-center">
                            <p className="text-gray-500 dark:text-gray-400 text-sm">
                              {pageData.noTestAvailableMesage}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="mb-4 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-xl overflow-hidden">
                          <div className="px-4 py-3 bg-gray-50 dark:bg-gray-800 border-b border-gray-300 dark:border-gray-700">
                            <label className="text-gray-700 text-xs dark:text-gray-300 font-medium">
                              {pageData.testHistoryLabel} ({companyInfoObject.tests_taken.length}{' '}
                              {pageData.testsLabel})
                            </label>
                          </div>

                          {companyInfoObject.tests_taken.map((test, testIndex) => (
                            <React.Fragment key={test._id || testIndex}>
                              {testIndex > 0 && (
                                <div className="px-4">
                                  <div className="h-[1px] bg-gray-200 dark:bg-gray-700"></div>
                                </div>
                              )}

                              <div className="p-4 space-y-3">
                                <div className="flex justify-between items-center">
                                  <span className="text-gray-900 dark:text-gray-300 text-xs font-normal">
                                    {pageData.dateAndTimeLabel}
                                  </span>
                                  <span className="text-gray-900 dark:text-gray-300 text-xs font-semibold">
                                    {test.completed_at
                                      ? `${new Date(
                                          test.completed_at
                                        ).toLocaleDateString()} | ${new Date(
                                          test.completed_at
                                        ).toLocaleTimeString([], {
                                          hour: '2-digit',
                                          minute: '2-digit'
                                        })}`
                                      : pageData.noDataAvailableMessage}
                                  </span>
                                </div>

                                <div className="flex justify-between items-center">
                                  <span className="text-gray-900 dark:text-gray-300 text-xs font-normal">
                                    {test.test_title || pageData.unknownTestLabel}
                                  </span>
                                  <button
                                    onClick={() => {
                                      getIndividualTestResults(test._id, test.test_title);
                                    }}
                                    className="text-[#4A57DA] dark:text-blue-400 text-xs font-medium bg-transparent border-none p-0 cursor-pointer hover:underline"
                                  >
                                    {pageData.viewResultsBtnTest}
                                  </button>
                                </div>

                                {/* Additional test info */}
                                <div className="flex justify-between items-center text-xs text-gray-500 dark:text-gray-400">
                                  <span>
                                    {pageData.scoreLabel} {test.score || 'N/A'}
                                  </span>
                                  <span>
                                    {pageData.resultLabel} {test.result_type || 'N/A'}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          {usersList.length > 0 && !loader ? (
            <Pagination
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={selectedPerPage?.value}
              onPageChange={(page) => {
                handlePagination(page, selectedPerPage?.value, searchTerm, sortBy, sortOrder);
              }}
            />
          ) : (
            <span />
          )}
        </div>
      </div>
    </>
  );
}

export default TestFeature;
